exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-review-step-confirm-table-container .sphere-table-container{position:relative}.asset-review-step-confirm-table-container .k-grid{max-height:calc(100vh - 409px);min-height:140px}\n", ""]);

// exports
